import * as React from 'react';
import { Table, Nav, NavItem, Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    & > tbody > tr > td {
        vertical-align: middle;
        border: 0 none;
    }

    & > tbody > tr > td > label {
        margin-bottom: 0px;
    }

    & > tbody > tr > td > .form-control-static {
        border: 1px solid #eee;
        border-radius: 4px;
        padding: 6px 12px;
    }
`;

export const ProfileWrapper = styled.div<{ horizontalFormLeftAlign?: boolean }>`
    padding-top: 10px;
    
    .nav > li.admin.active > a {
        background-color: orange;
        color: white;
        font-weight: normal;
    }

    .nav > li.admin > a {
        color: orange;
        font-weight: bold;
    }

    .donor-profile-section {
        border-width: 1px 1px 1px 1px;
        border-style: solid;
        // border-color: #337ab7;
        border-color: #ddd;
        // border-radius: 4px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .donor-profile-section-medical-details {
        .form-control-static {
            padding-bottom: 3px;
        }
    }

    .donor-profile-content {
        .form-group {
            // border: 1px solid red;
        }

        .yes-no-unknown {
            height: 34px;
            padding-top: 7px;
        }
    }

    .donor-profile-adp {
        // border-bottom: 1px solid #ccc;
        border-radius: 4px;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .form-horizontal .form-group {
        margin-bottom: 5px;
    }

    .form-horizontal .control-label {
        text-align: ${p => p.horizontalFormLeftAlign ? p.horizontalFormLeftAlign : 'left'};
    }

    .declines span.label {
        font-size: 100%;
        display: block;
        width: 50px;
        padding: .4em .6em .4em;
    }

    .declines .decline-label {
        padding-top: 0.4rem;
    }

    .accepts > table > thead > tr > th,
    .accepts > table > tbody > tr > td {
        text-align: center;
    }

    .accepts > table > tbody > tr > td > .label {
        font-size: 100%;
    }

    .panel-heading {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .donor-records > .row:nth-child(odd) {
        background-color: #eee;
        padding-top: 5px;
        padding-bottom: 5px;
    }
`;

export const ButtonWrapper = styled.div`
    .btn {
        height: 55px;
        margin: 3px;
        min-width: 80px;
    }
`;

export const NavWrapper = styled(Nav)`
    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: white;
        color: black;
        // width: 160px;
        text-align: center;
        border-width: 1px 1px 0px 1px;
        border-style: solid;
        border-color: #ddd;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: #337ab7;
        color: white;
    }

    & > li.active > a {
        font-size: 16px;
        line-height: 20px;
        background-color: #337ab7;
        color: white;
    }

    @media (max-width: 1823px) {
        & > li > a {
            font-size: 13px;
            line-height: 20px;
        }

        & > li.active > a {
            font-size: 14px;
            line-height: 20px;
        }
    }
`;

interface INavItemProps {
    tabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: 140px;
    // }
`;

export const NavItemStaticWrapper = styled.label`
    background-color: #337ab7 !important;
    color: white !important;
    float: left !important;
    margin-top: 5px;
    margin-right: 5px;
    border-radius: 5px;
    text-align: center;
    padding: 5px;    
`;

export const RecordsTableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        background-color: lightgray;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
    }

    & > tbody > tr > td:nth-child(1) {
        text-align: left;
    }
`;

export const TabWrapper = styled.div`
    width: 100%;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    min-height: 70vh;
    padding: 10px;
    background-color: #FFF;
`;

export const HeaderWrapper = styled.div<{ expand: boolean }>`
    margin-bottom: 10px;
    padding-top: 3px;
    padding-bottom: 3px;
    
    .donor-progress-bar {
        min-height: 40px;
        padding: 5px;
        display: flex;
        align-items: center;
    }

    .header-left {
        display: flex;
        align-items: center;
        padding-right: 20px;
        flex-grow: 1;
        flex-basis: 100px;
        cursor: default;
    }

    .header-buttons {
        flex-grow: 5;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .header-buttons > .item-button {
        flex-grow: 2;
        flex-basis: 250px;
    }

    .header-buttons > .item-divider {
        padding-left: 10px;
        padding-right: 10px;
        flex-grow: 1;
        color: #ddd;
        text-align: center;
        // border: 1px solid green;
    }

    .donor-progress-messages {
        padding: 5px 10px 10px 10px;
    }
`;

export const ModalBodyWrapper = styled(Modal.Body)`
    .form-group {
        margin-bottom: 10px;
    }

    .control-label {
        margin-bottom: 3px;
    }
`;

export const styles: { [key: string]: React.CSSProperties } = {
    progressMessage: {
        marginBottom: 5
    },
    progressMessageIntro: {
        marginBottom: 5
    },
    progressMessageList: {
        paddingInlineStart: 20
    },
    progressMessageListItem: {
        listStyleType: 'disc'
    }
};